function isASTTextNode(node) {
  return !!node && node.nodeType === "text";
}

export { isASTTextNode };
//# sourceMappingURL=core.text.js.map
